const GROUPS_IDS = {
  customer_experience: 43000265283,
  partner_atraction: 43000289112,
  product_development: 43000289113,
  partner_development: 43000594626,
  executive: 43000610294,
  finantial: 43000289119,
  marketing_and_sales: 43000265210,
  customer_success: 43000610745
};

const AGENTS_IDS = {
  andre_fehrenbach: 43009315822,
  ariane_tavares: 43058657980,
  guilherme_figueira: 43051250193,
  gustavo_donamaid: 43009754878,
  janine_schneiders: 43009754867,
  kellerson_kurtz: 43009314287,
  matheus_furtado: 43063048803,
  melissa_braga: 43058657902,
  recrutamento_donamaid: 43025036773,
  ruben_pacheco: 43009736561
};

const TICKET_STATUS_CODE = {
  open: 2,
  closed: 3,
  pendent: 4,
  solved: 5
};

const TICKET_PRIORITY_CODE = {
  low: 1,
  medium: 2,
  high: 3,
  urgent: 4
};

function getGroupIds(groupName) {
  return GROUPS_IDS[groupName];
}

function getAgentIds(agentName) {
  return AGENTS_IDS[agentName];
}

function getTicketStatusCode(code) {
  return TICKET_STATUS_CODE[code];
}

function getTicketPriority(code) {
  return TICKET_PRIORITY_CODE[code];
}

export default {
  getGroupIds,
  getAgentIds,
  getTicketPriority,
  getTicketStatusCode
};



// WEBPACK FOOTER //
// ./src/utils/helpers/freshdesk.js